import { render, staticRenderFns } from "./UserStatements.vue?vue&type=template&id=356ec458&scoped=true&"
import script from "./UserStatements.vue?vue&type=script&lang=js&"
export * from "./UserStatements.vue?vue&type=script&lang=js&"
import style0 from "./UserStatements.vue?vue&type=style&index=0&id=356ec458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ec458",
  null
  
)

export default component.exports